__turbopack_context__.v({
  "animation": "jIehRG_animation",
  "border": "jIehRG_border",
  "borderAnimated": "jIehRG_borderAnimated",
  "borderContainer": "jIehRG_borderContainer",
  "container": "jIehRG_container",
  "content": "jIehRG_content",
  "icon": "jIehRG_icon",
  "image": "jIehRG_image",
  "rotate": "jIehRG_rotate",
});
